import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../tooltip';
import { StationRatingCategoryScores } from '../../../utils/prop-types/rating-types';
import ImageWithText from '../../image-with-text';
import RatingCategorySvg from '../rating-category-svg';

import sharedStyles from '../../../styles/shared.css';
import styles from './styles.css';
import { RatingScoreLabels } from '../../../../lib/constants/enums';

const RatingScoreLabelDisplayNames = {
  good: 'Top Marks',
  average: 'Average',
  poor: 'Needs Work',
};

class RatingsCategoryScoreContent extends React.Component {
  static propTypes = {
    ratingCategoryScores: PropTypes.arrayOf(StationRatingCategoryScores),
  }

  static defaultProps = {
    ratingCategoryScores: {},
  }

  static getScoreSpecificUIInfo = (ratingScoreLabel) => {
    switch (ratingScoreLabel) {
      case RatingScoreLabels.good:
        return { color: '#63A817', noDataMessage: 'Needs some improvement' };
      case RatingScoreLabels.average:
        return { color: '#0097a9', noDataMessage: 'No average categories' };
      case RatingScoreLabels.poor:
        return { color: '#EE5340', noDataMessage: 'Nothing urgent for now' };
      default:
        return { color: '#B5BBBF', noDataMessage: 'N/A' };
    }
  }

  renderCategoryScoreRow = (data, label) => {
    let rowMarkup;
    const { color, noDataMessage } = RatingsCategoryScoreContent.getScoreSpecificUIInfo(label);
    if (data[label].length) {
      rowMarkup = data[label].map((c) => {
        const categoryIcon = (
          <RatingCategorySvg
            categoryId={c.category_id}
            color={color}
          />
        );
        return (
          <div
            key={`${label}${c.category_id}`}
            id={`${label}${c.category_id}`}
            className={styles.row}
          >
            <ImageWithText
              className={styles.categoryText}
              text={c.category_name}
              imageWidth={30}
              imageHeight={30}
              imageName={c.category_name}
              svgContent={categoryIcon}
            />
            <Tooltip
              tootipContent={`The current score of ${c.category_name} is ${RatingScoreLabelDisplayNames[label]}`}
              uniqueTargetSelector={`${label}${c.category_id}`}
            />
          </div>
        );
      });
    } else {
      rowMarkup = (
        <div className={styles.noScoreData} style={{ textAlign: 'center', margin: '10px 0px' }}>
          {noDataMessage}
        </div>
      );
    }

    return (
      <>
        <div className={`${styles.header} ${styles[label]}`}>{RatingScoreLabelDisplayNames[label]}</div>
        <div className={styles.table}>
          {rowMarkup}
        </div>
      </>
    );
  }

  render() {
    const { ratingCategoryScores } = this.props;
    const scores = ratingCategoryScores.filter(rs => rs.category_id !== 1)
      .map(rs => ({
        category_id: rs.category_id,
        category_name: rs.category_name,
        label: rs.label,
        // value: gbutils.convertLabelToRatingValue(rs.label),
        // hexFill: gbutils.convertRatingValueToHex(gbutils.convertLabelToRatingValue(rs.label)),
      }));

    const ratingScoreMap = {
      good: scores.filter(rs => rs.label === RatingScoreLabels.good),
      average: scores.filter(rs => rs.label === RatingScoreLabels.average),
      poor: scores.filter(rs => rs.label === RatingScoreLabels.poor),
    };

    return (
      <div className={styles.ratingCategoryScore}>
        {this.renderCategoryScoreRow(ratingScoreMap, 'good')}
        <div className={`${sharedStyles.dottedBorderBottom}`}>&nbsp;</div>
        {this.renderCategoryScoreRow(ratingScoreMap, 'average')}
        <div className={`${sharedStyles.dottedBorderBottom}`}>&nbsp;</div>
        {this.renderCategoryScoreRow(ratingScoreMap, 'poor')}
      </div>
    );
  }
}

export default RatingsCategoryScoreContent;
